const vsc = {
  six: 250,
  eight: 300,
  ten: 370,
  twelve: 450,
  rt: 1444,
};
const rls = {
  six: 300,
  eight: 350,
  ten: 420,
  twelve: 500,
};
const bdc = {
  six: 320,
  eight: 380,
  ten: 450,
  twelve: 550,
};
const Calc = ({ size, flavour, price }) => {
  if (
    size === "6" &&
    (flavour === "Vanilla" ||
      flavour === "Salted caramel" ||
      flavour === "Chocolate")
  ) {
    price = vsc.six;
    return price;
  } else if (
    size === "8" &&
    (flavour === "Vanilla" ||
      flavour === "Salted caramel" ||
      flavour === "Chocolate")
  ) {
    price = vsc.eight;
    return price;
  } else if (
    size === "10" &&
    (flavour === "Vanilla" ||
      flavour === "Salted caramel" ||
      flavour === "Chocolate")
  ) {
    price = vsc.ten;
    return price;
  } else if (
    size === "12" &&
    (flavour === "Vanilla" ||
      flavour === "Salted caramel" ||
      flavour === "Chocolate")
  ) {
    price = vsc.twelve;
    return price;
    //2nd batch
  } else if (
    size === "6" &&
    (flavour === "Red velvet" ||
      flavour === "Lemon" ||
      flavour === "Strawberry")
  ) {
    price = rls.six;
    return price;
  } else if (
    size === "8" &&
    (flavour === "Red velvet" ||
      flavour === "Lemon" ||
      flavour === "Strawberry")
  ) {
    price = rls.eight;
    return price;
  } else if (
    size === "10" &&
    (flavour === "Red velvet" ||
      flavour === "Lemon" ||
      flavour === "Strawberry")
  ) {
    price = rls.ten;
    return price;
  } else if (
    size === "12" &&
    (flavour === "Red velvet" ||
      flavour === "Lemon" ||
      flavour === "Strawberry")
  ) {
    price = rls.twelve;
    return price;
  } else if (
    size === "6" &&
    (flavour === "Berry vanilla" ||
      flavour === "Double chocolate" ||
      flavour === "Champagne strawberry")
  ) {
    price = bdc.six;
    return price;
  } else if (
    size === "8" &&
    (flavour === "Berry vanilla" ||
      flavour === "Double chocolate" ||
      flavour === "Champagne strawberry")
  ) {
    price = bdc.eight;
    return price;
  } else if (
    size === "10" &&
    (flavour === "Berry vanilla" ||
      flavour === "Double chocolate" ||
      flavour === "Champagne strawberry")
  ) {
    price = bdc.ten;
    return price;
  } else if (
    size === "12" &&
    (flavour === "Berry vanilla" ||
      flavour === "Double chocolate" ||
      flavour === "Champagne strawberry")
  ) {
    price = bdc.twelve;
    return price;
  } else {
    price = 0;
    return price;
  }
};

export default Calc;
